import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyEmail, resendVerificationCode } from '../Data/dataApi';
import '../Css/verifyemail.css';

const VerifyEmail: React.FC = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;

  const handleVerify = async () => {
    if (!code) {
      setError("Please enter the verification code");
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const result = await verifyEmail({
        email,
        code
      });

      if (result.success) {
        setSuccess("Email verified successfully!");

        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setError(result.message || "Invalid code");
      }

    } catch {
      setError("Verification failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0) return;

    try {
      setError('');
      setSuccess('');

      const result = await resendVerificationCode(email);

      if (result.success) {
        setSuccess("New code sent 📧");

        // ⏳ START COOLDOWN 60 sec
        setCooldown(60);

        const interval = setInterval(() => {
          setCooldown((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);

      } else {
        setError(result.message || "Failed to resend code");
      }

    } catch {
      setError("Failed to resend code");
    }
  };

  if (!email) {
    return <p>Error: email not found</p>;
  }

  return (
    <div className="verify-container">
      <div className="verify-card">
        <h2 className="verify-title">Verify your email</h2>

        <p className="verify-subtitle">
          We sent a code to<br />
          <span className="verify-email">{email}</span>
        </p>

        <input
          type="text"
          className="verify-input"
          value={code}
          onChange={(e) => setCode(e.target.value.slice(0, 6))}
          placeholder="------"
        />

        <button
          className="verify-button"
          onClick={handleVerify}
          disabled={loading}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>

        <button
          className="verify-resend"
          onClick={handleResend}
          disabled={cooldown > 0}
        >
          {cooldown > 0
            ? `Resend in ${cooldown}s`
            : "Resend code"}
        </button>

        {error && <p className="verify-error">{error}</p>}
        {success && <p className="verify-success">{success}</p>}
      </div>
    </div>
  );
};

export default VerifyEmail;